module.exports = function(bootstrap) {
    bootstrap.run(["Service","sessionData", function (Service, sessionData) {
            new Service({
                name: 'clientInformation',
                group:"eprsvc",
                url:"/eprsvc/x-services/secure/client-information/v1/",
                headers: {},
                cache: false,
                getGroups: function() {
                    this.url += "groups";
                    this.headers['APPID'] = "EPRWEB";
                    this.headers['clientHost'] = "hmhs.com";
                    if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                        this.headers['ClientNumber']  = sessionData.clientNumber;
                    }
                    return this.get();
                },
                getBrandGroups: function(loginId,destinationBrand) {                    
                    this.url += "multibrand/groups/" + loginId + "/" + destinationBrand;
                    this.headers['APPID'] = "EPRWEB";
                    this.headers['clientHost'] = "hmhs.com";
                    if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                        this.headers['ClientNumber']  = sessionData.clientNumber;
                    }
                    return this.get();
                },
                getGeneralInfo: function() {
                    this.url += "general-information";
                    this.headers['APPID'] = "EPRWEB";
                    this.headers['clientHost'] = "hmhs.com";
                    if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                        this.headers['ClientNumber']  = sessionData.clientNumber;
                    }
                    return this.get();
                },
                getContacts: function() {
                    this.url += "contacts";
                    this.headers['APPID'] = "EPRWEB";
                    this.headers['clientHost'] = "hmhs.com";
                    if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                        this.headers['ClientNumber']  = sessionData.clientNumber;
                    }
                    return this.get();
                },
                getReportCodes: function() {
                    this.url += "report-codes";
                    this.headers['APPID'] = "EPRWEB";
                    this.headers['clientHost'] = "hmhs.com";
                    if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                        this.headers['ClientNumber']  = sessionData.clientNumber;
                    }
                    return this.get();
                }
            });
        }]);
};
